/**
 * CustomerInfoTab.tsx
 * Component độc lập hiển thị thông tin hồ sơ chi tiết (Chi tiết) của khách hàng.
 */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { colors, spacing, fontWeights, borderRadius } from '../../theme';
import type { CustomerFull } from '../../data/customers';

export interface CustomerInfoTabProps {
  customer: CustomerFull;
}

export const CustomerInfoTab: React.FC<CustomerInfoTabProps> = ({ customer }) => {
  return (
    <View style={styles.infoBlock}>
      <Text style={styles.infoBlockTitle}>Thông tin hồ sơ</Text>
      <View style={styles.infoRowSimple}>
        <Text style={styles.infoRowLbl}>Họ và tên:</Text>
        <Text style={styles.infoRowVal}>{customer.name}</Text>
      </View>
      <View style={styles.infoRowSimple}>
        <Text style={styles.infoRowLbl}>Giới tính:</Text>
        <Text style={styles.infoRowVal}>{customer.gender}</Text>
      </View>
      <View style={styles.infoRowSimple}>
        <Text style={styles.infoRowLbl}>Ngày sinh:</Text>
        <Text style={styles.infoRowVal}>{customer.dob} ({customer.age} tuổi)</Text>
      </View>
      <View style={styles.infoRowSimple}>
        <Text style={styles.infoRowLbl}>Nghề nghiệp:</Text>
        <Text style={styles.infoRowVal}>{customer.occupation}</Text>
      </View>
      <View style={styles.infoRowSimple}>
        <Text style={styles.infoRowLbl}>Địa chỉ:</Text>
        <Text style={styles.infoRowVal}>{customer.address || 'Chưa cập nhật'}</Text>
      </View>
      <View style={styles.infoRowSimple}>
        <Text style={styles.infoRowLbl}>Ngày tạo HS:</Text>
        <Text style={styles.infoRowVal}>{customer.createdAt}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  infoBlock: {
    backgroundColor: '#f8fafc',
    borderRadius: borderRadius.DEFAULT,
    padding: spacing[4],
    borderWidth: 1,
    borderColor: colors.outlineVariant,
    gap: spacing[2],
  },
  infoBlockTitle: {
    fontSize: 14,
    fontWeight: fontWeights.bold,
    color: colors.onSurface,
    marginBottom: spacing[1],
  },
  infoRowSimple: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: spacing[1],
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: '#e2e8f0',
  },
  infoRowLbl: {
    fontSize: 12,
    color: colors.onSurfaceVariant,
  },
  infoRowVal: {
    fontSize: 12,
    fontWeight: fontWeights.semibold,
    color: colors.onSurface,
  },
});
